import { Box, Typography } from '@mui/material';
import { summary } from '../../data/networkData';

const DONUT_DATA = [
  { name: 'Online',     value: summary.online,     color: '#4caf50' },
  { name: 'Offline',    value: summary.offline,    color: '#f44336' },
  { name: 'Unassigned', value: summary.unassigned, color: '#1e3a5f' },
];

function polarToCartesian(cx, cy, r, angleDeg) {
  const rad = ((angleDeg - 90) * Math.PI) / 180;
  return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
}

function arcPath(cx, cy, outerR, innerR, startAngle, endAngle) {
  const o1 = polarToCartesian(cx, cy, outerR, startAngle);
  const o2 = polarToCartesian(cx, cy, outerR, endAngle);
  const i1 = polarToCartesian(cx, cy, innerR, endAngle);
  const i2 = polarToCartesian(cx, cy, innerR, startAngle);
  const large = endAngle - startAngle > 180 ? 1 : 0;
  return [`M ${o1.x} ${o1.y}`, `A ${outerR} ${outerR} 0 ${large} 1 ${o2.x} ${o2.y}`,
          `L ${i1.x} ${i1.y}`, `A ${innerR} ${innerR} 0 ${large} 0 ${i2.x} ${i2.y}`, 'Z'].join(' ');
}

function DonutChart() {
  const size = 120; const cx = 60; const cy = 60;
  const outerR = 54; const innerR = 36;
  const total = DONUT_DATA.reduce((s, d) => s + d.value, 0);
  let angle = 0;
  return (
    <svg width={size} height={size}>
      {DONUT_DATA.map((seg) => {
        const sweep = (seg.value / total) * 360;
        const path = arcPath(cx, cy, outerR, innerR, angle, angle + sweep);
        angle += sweep;
        return sweep > 0.1 ? <path key={seg.name} d={path} fill={seg.color} /> : null;
      })}
    </svg>
  );
}

export default function AssetsWidget() {
  return (
    <Box sx={{ padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 3 }}>

      {/* Donut */}
      <Box sx={{ position: 'relative', width: 120, height: 120, flexShrink: 0 }}>
        <DonutChart />
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', textAlign: 'center', pointerEvents: 'none' }}>
          <Typography sx={{ color: '#ffffff', fontWeight: 700, fontSize: 22, lineHeight: 1 }}>{summary.totalDevices}</Typography>
          <Typography sx={{ color: '#7a8fa6', fontSize: 9, display: 'block' }}>DEVICES</Typography>
        </Box>
      </Box>

      {/* Stats */}
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1.25 }}>
        {DONUT_DATA.map((d) => (
          <Box key={d.name} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
              <Box sx={{ width: 7, height: 7, borderRadius: '50%', backgroundColor: d.color }} />
              <Typography sx={{ color: '#7a8fa6', fontSize: 12 }}>{d.name}</Typography>
            </Box>
            <Typography sx={{ color: '#ffffff', fontWeight: 700, fontSize: 13 }}>{d.value}</Typography>
          </Box>
        ))}
        <Box sx={{ marginTop: 0.5 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: 0.4 }}>
            <Typography sx={{ color: '#7a8fa6', fontSize: 11 }}>IP Utilization</Typography>
            <Typography sx={{ color: '#00bcd4', fontWeight: 700, fontSize: 11 }}>{Math.round((summary.assigned / summary.totalIPs) * 100)}%</Typography>
          </Box>
          <Box sx={{ height: 4, borderRadius: 2, backgroundColor: '#1e3a5f' }}>
            <Box sx={{ height: 4, borderRadius: 2, backgroundColor: '#00bcd4', width: `${(summary.assigned / summary.totalIPs) * 100}%` }} />
          </Box>
        </Box>
      </Box>

    </Box>
  );
}
